module.exports = __webpack_public_path__ + "img/line-chart-selected.e9a08b01.svg";